<template>
  <div class="view content">
    <div class="container content">
      <div class="main-title">Conditions générales d'utilisation et conditions générales de vente</div>
      <div class="title">PRÉAMBULE</div>
      <div class="paragraph">
        Les présentes conditions générales d'utilisation et de vente (ci-après « les CGUV») s'appliquent aux conditions d'accès et d'utilisation du site «
        www.kyc.infogreffe.fr » (ci-après le « Site ») et aux services accessibles à partir du Site, notamment en ce qui concerne le Service (tel que ce terme
        est défini ci-après) ainsi qu’ à l'utilisation du serveur WEB Infogreffe et à la commande puis à l'utilisation des informations et actes issus des
        registres des greffes des Tribunaux de commerce, membres d’INFOGREFFE (tel qu’identifié ci-après) et des greffes publics des Tribunaux d'instance à
        compétence commerciale et des Tribunaux mixtes de commerce.
        <br />
        <br />
        Le Site est édité par INFOGREFFE et les prestations accessibles à partir du Site (et notamment le Service), notamment en ce qui concerne le Service (tel
        que ce terme est défini ci-après), sont réalisées par le GIE INFOGREFFE (ci-après «INFOGREFFE»), dont l’identification est la suivante : Infogreffe est
        un Groupement d'intérêt économique (de nature civile), immatriculé au registre du commerce et des sociétés de Créteil sous le numéro 338 885 718 et dont
        le siège social est situé 5-7 Avenue de Paris, 94 300 Vincennes.
        <br />
        <br />
        La consultation du Site par tout Utilisateur et l'accès aux services déployés à partir du Site, et notamment le Service, sont subordonnés à la
        consultation, l'acceptation préalable et au respect intégral des présentes CGUV.
      </div>
      <div class="title">ARTICLE 1 - DÉFINITIONS</div>
      <div class="paragraph">
        Dans les CGU / CGV, les mots ou expressions commençant avec une majuscule ont la signification qui suit :
        <br />
        <br />
        - Site : le présent site web, qui est accessible à l'adresse suivante : www.kyc-infogreffe.fr.
        <br />
        <br />
        - Service : désigne le service de mise sous surveillance d’une ou plusieurs entreprises choisies par le Client (tel que ce terme est défini ci-après)
        aux fins de bénéficier d’une mise à disposition automatique et sous forme électronique des actes relatifs à ces entreprises et pouvant être délivrés par
        les Greffes en exécution de leur mission légale, le Service étant plus amplement décrit à l’article 3 ci-après.
        <br />
        <br />
        - Client : désigne toute personne ayant souscrit le Contrat lui donnant accès au Service, comme indiqué à l’article 2 ci-après.
        <br />
        <br />
        - Contrat : désigne le contrat identifié à l’article 2 ci-après.
        <br />
        <br />
        - Utilisateur : désigne toute personne (en ce compris l'Utilisateur Consommateur et l'Utilisateur Professionnel) qui visite une ou plusieurs pages du
        Site et, plus globalement, utilise le Site.
        <br />
        <br />
        - Utilisateur Consommateur : désigne tout Utilisateur personne physique qui agit à des fins qui n'entrent pas dans le cadre de son activité commerciale,
        industrielle, artisanale ou libérale.
        <br />
        <br />
        - Utilisateur Professionnel : désigne tout Utilisateur personne physique ou morale, publique ou privée, qui agit à des fins entrant dans le cadre de son
        activité commerciale, industrielle, artisanale ou agricole y compris lorsqu'il agit au nom ou pour le compte d'un autre professionnel.
        <br />
        <br />
        - Greffe : désigne tout greffe des Tribunaux de commerce, membre d’INFOGREFFE et tous les greffes publics des Tribunaux judiciaires à compétence
        commerciale et des Tribunaux mixtes de commerce dont les actes ou services sont accessibles à partir du Site et/ou dans le cadre du Service.
      </div>
      <div class="title">ARTICLE 2 - ACCÈS AU SITE ET AU SERVICE</div>
      <div class="paragraph">
        La consultation du Site est accessible gratuitement à tout Utilisateur disposant d'un accès internet et d’un compte abonné. L'ensemble des coûts
        afférents à l'accès au Site, que ce soient les frais matériels, logiciels ou d'accès à internet sont exclusivement à la charge de l'Utilisateur.
        L’Utilisateur est seul responsable du bon fonctionnement de son équipement informatique ainsi que de son accès internet.
        <br />
        <br />
        L’accès au Service, quant à lui, implique la souscription par l’Utilisateur d’un contrat (le « Contrat »), en qualité de Client (tel que ce terme est
        défini au Contrat). Afin de souscrire au Contrat, l’Utilisateur devra contacter directement les services d’Infogreffe (se rendre dans la rubrique «
        Contact »).
        <br />
        <br />
        A la souscription du Contrat, Infogreffe procède à la création du compte permettant au Client d’accéder au Service, et communique au Client les
        identifiants permettant de se connecter audit compte. Dans le cadre de la création de ce compte, le Client s'engage à fournir des informations exactes
        et à jour. En outre, l’accès au Service implique la désignation, par le Client, d’un ou de plusieurs utilisateurs principaux. Le ou les utilisateurs
        principaux du compte peuvent procéder à la création de de profils d’utilisateurs secondaires. Le Client est seul responsable du respect des présentes
        CGU par le ou les utilisateurs principaux et secondaires.
        <br />
        <br />
        INFOGREFFE se réserve le droit de refuser l'accès au Site et/ou au Service, unilatéralement et sans notification préalable, à tout Utilisateur ne
        respectant pas les présentes CGUV.
        <br />
        <br />
        A titre d'information et sans engament d'INFOGREFFE à ce titre, il est indiqué que le Site est accessible 24 heures sur 24, 7 jours sur 7, sauf cas de
        force majeure, cas fortuit ou du fait d'un tiers, tels que ceux habituellement retenus et définis par la jurisprudence des Tribunaux français. De même,
        INFOGREFFE se réserve le droit de procéder à toute interruption pour raison de maintenance technique nécessaire au bon fonctionnement du Site et des
        matériels afférents, ou de mise à jour du Site ou pour toute autre raison.
        <br />
        <br />
        INFOGREFFE se réserve également le droit de suspendre, interrompre ou de limiter, à tout moment et pour la durée de son choix (en ce inclus tout arrêt
        définitif) sans avis préalable, l'accès à tout ou partie du Site.
        <br />
        <br />
        INFOGREFFE n'est tenu à aucune obligation de résultat concernant l'accessibilité au Site, et, n'est en aucun cas responsable des interruptions et des
        conséquences qui peuvent en découler.
      </div>
      <div class="title">ARTICLE 3 - CARACTÉRISTIQUES DES SERVICES - PRIX</div>
      <div class="paragraph">
        Le Service consiste en une mise sous surveillance d’une ou plusieurs entreprises choisies par le Client aux fins de bénéficier d’une mise à disposition
        automatique et sous forme électronique des certains actes relatifs à ces entreprises, et pouvant être délivrés par les Greffes en exécution de leur
        mission légale.
        <br />
        <br />
        Le descriptif du Service, son prix, et ses modalités de paiements figurent au Contrat.
      </div>
      <div class="title">ARTICLE 4 - COMMANDE EN LIGNE - INSCRIPTION</div>
      <div class="paragraph">
        Dans le cadre de son inscription et/ou de ses opérations de commande et/ou de la souscription du Contrat, l’Utilisateur s’engage à fournir des
        informations exactes et à jour.
        <br />
        <br />
        A partir de la « Fiche entreprise » ou de la liste des résultats sélectionnés, l'Utilisateur peut choisir dans la rubrique « Mettre sous surveillance »
        d’appliquer le Service pour cette entreprise.
      </div>
      <div class="title">ARTICLE 5 - CONFIRMATION DE COMMANDE DU SERVICE</div>
      <div class="paragraph">
        Afin de placer une entreprise sous surveillance, l'Utilisateur doit indiquer dans la rubrique « Informations de surveillance » le niveau de surveillance
        qu’il souhaite appliquer à cette entreprise (i), la référence de son choix (ii), et renseigner le gestionnaire associé à cette surveillance (iii).
        <br />
        <br />
        Avant que l’entreprise ne soit placée sous surveillance et que les documents ne soient adressés à l’Utilisateur, une validation de la mise sous
        surveillance sera demandée à l’Utilisateur.
        <br />
        <br />
        Une fois la mise sous surveillance confirmée par l’Utilisateur, l’entreprise figurera dans le portefeuille de l’Utilisateur vingt-quatre heures après
        cette confirmation.
        <br />
        <br />
        Les actes objets du Service sont stockés dans l’espace client pour une durée de cinq (5) ans à compter de leur transmission par INFOGREFFE, et sont
        accessibles au Client pendant cette durée tant que celui-ci bénéficie du Contrat. En outre, dans le cas où le Client souhaiterait procéder à la
        suppression de son compte, les documents obtenus par le biais du Service seront également supprimés.
      </div>
      <div class="title">ARTICLE 6 - DROIT DE RÉTRACTATION</div>
      <div class="paragraph">
        6.1. Contrat et Service
        <br />
        <br />
        L’Utilisateur Consommateur dispose d’un délai de quatorze (14) jours pour exercer son droit de rétractation à compter de la conclusion du Contrat
        ouvrant droit au Service. Pour exercer son droit de rétractation, l’Utilisateur Consommateur doit notifier sa décision de rétractation avant
        l’expiration du délai précité, au moyen d’une déclaration dénuée d’ambiguïté, par exemple en utilisant le
        <a class="link" href="https://infogreffekycprod1.blob.core.windows.net/cgv/Formulaire de rétractation_v23072020.pdf" target="blank"
          >formulaire de rétractation accessible ici</a
        >, à l’adresse suivante : 5-7 avenue de Paris, 94300 Vincennes.
        <br />
        <br />
        6.2. Services immédiatement et pleinement exécutés
        <br />
        <br />
        Conformément à l'article L. 221-28 du Code de la consommation, le droit de rétractation ne peut être exercé pour la fourniture de services pleinement
        exécutés avant la fin du délai de rétractation et dont l'exécution a commencé après accord préalable exprès du consommateur et renoncement exprès à son
        droit de rétractation.
        <br />
        <br />
        Si l’Utilisateur Consommateur souhaite une mise sous surveillance immédiate de l’entreprise et, ainsi, un accès immédiat aux actes et informations
        concernant cette entreprise, ce dernier doit accepter la stipulation lui étant proposée, au moment de la commande, selon laquelle il souhaite un tel
        accès immédiat et, par conséquent, qu’il renonce expressément à son droit de rétractation.
      </div>
      <div class="title">ARTICLE 7 - PROPRIÉTÉ INTELLECTUELLE</div>
      <div class="paragraph">
        Tous les éléments du Site sont et restent la propriété intellectuelle et exclusive d'INFOGREFFE.
        <br />
        <br />
        Toute reproduction, exploitation, rediffusion ou utilisation des éléments du Site, qu'ils soient textuels, logiciels, visuels ou sonores, est
        strictement interdite sous peine de poursuites, notamment pénales. Tout lien simple ou par hypertexte, sur le Site, est strictement interdit sans un
        accord écrit exprès d'INFOGREFFE.
        <br />
        <br />
        La marque INFOGREFFE, ainsi que le logo figurant sur le Site sont des marques déposées (semi-figuratives ou non). Toute reproduction totale ou partielle
        de ces marques ou de ces logos effectués à partir des éléments du Site sans l'autorisation expresse d'Infogreffe est prohibée, au sens des articles
        L.713-2 et suivants du Code de la propriété intellectuelle.
      </div>
      <div class="title">ARTICLE 8 - MODIFICATION DES CGUV</div>
      <div class="paragraph">
        INFOGREFFE se réserve le droit, à tout moment, de modifier ou de mettre à jour tout ou partie des CGU-CGV, notamment en cas de modification des missions
        de service public confiés aux Greffes.
        <br />
        <br />
        Il est donc conseillé à l'Utilisateur de se référer régulièrement à la dernière version des CGUV disponible en permanence sur le Site.
        <br />
        <br />
        Si une ou plusieurs stipulations des CGUV sont tenues pour non valides ou déclarées comme telles en application d'une loi, d'un règlement ou à la suite
        d'une décision définitive d'une juridiction compétente, elles seront réputées non écrites et les autres stipulations demeureront en vigueur.
      </div>
      <div class="title">ARTICLE 9 - RESPONSABILITÉ</div>
      <div class="paragraph">
        L’Utilisateur est le seul responsable des recherches des actes et/ou informations qu’il effectue ainsi que des conséquences directes ou indirectes de
        l’utilisation par ses soins des actes et/ou informations ainsi obtenus. A ce titre, notamment, il appartient au Client de faire un usage conforme à la
        réglementation en vigueur des actes commandés par ses soins et/ou des informations auxquelles il a ainsi accès. En aucun cas, les Greffes et/ou
        INFOGREFFE ne pourront être tenus pour responsable d’un quelconque dommage, de quelque nature que ce soit, résultant de l’utilisation par le Client des
        dits actes et/ou informations. Le Client garantit les Greffes et/ou INFOGREFFE contre toute réclamation revendication et/ou recours de toute sorte
        résultant de toute violation de ces stipulations.
        <br />
        <br />
        En tout état de cause, et comme également stipulé aux CGUV, la responsabilité des Greffiers ne peut être engagée pour retard ou défaillance tenant soit
        à un cas de force majeure, soit à un événement échappant à leur contrôle, soit encore du fait du Client.
        <br />
        <br />
        INFOGREFFE ne supporte en aucun cas la responsabilité des données produites par les Greffes. En effet, il est rappelé qu’INFOGREFFE intervient en
        qualité de mandataire des Greffes et n’est à ce titre en aucun cas responsable de l’exactitude et de la complétude des documents commandées et des
        informations y figurant dans la mesure où ces dernières lui sont transmises par les Greffes.
        <br />
        <br />
        Il est expressément convenu que si la responsabilité d’un Greffier et/ou d’INFOGREFFE était retenue l’Utilisateur Professionnel ne pourrait prétendre à
        d’autres indemnités et dommages et intérêts, que le remboursement des règlements qu’il a déjà effectués pour la partie du Service où se révèle une
        défaillance ou une erreur imputable au Greffier concerné ou le non-paiement de cette partie du Service étant en outre précisé que la responsabilité des
        Greffiers et/ou INFOGREFFE est en tout état de cause limitée aux préjudices directs à l’exclusion de tous préjudices indirects.
        <br />
        <br />
        En effet, il est convenu et accepté qu’en aucun cas, INFOGREFFE et/ou les Greffiers ne prendront en charge l’indemnisation des dommages immatériels
        et/ou indirects tels que, notamment, préjudice commercial, préjudice d’exploitation, perte de bénéfice, manque à gagner, forclusion dans la production
        de créances, etc.
        <br />
        <br />
        INFOGREFFE et/ou un Greffe ne saurait être tenu responsable du non-fonctionnement, d'une impossibilité d'accès ou de dysfonctionnement des services du
        fournisseur d'accès des Utilisateurs, à ceux du réseau internet. Il en sera de même pour toutes autres raisons extérieures à INFOGREFFE et/ou un Greffe.
        <br />
        <br />
        Par ailleurs, il est précisé que l’Utilisateur est seul responsable des annotations qu’il rédige dans le cadre de la rubrique « Note », accessible
        depuis la « Fiche entreprise ». En aucun cas INFOGREFFE et/ou un Greffe ne saurait être tenu responsable des conséquences directes ou indirectes de
        l’utilisation par l’Utilisateur de ladite rubrique.
        <br />
        <br />
        L'Utilisateur déclare être bien informé des caractéristiques intrinsèques de l'internet et notamment du fait (i) que la transmission des informations
        sur l'internet ne bénéficie que d'une fiabilité relative, celles-ci circulant sur des réseaux hétérogènes, aux caractéristiques et capacités diverses,
        qui sont parfois saturés à certaines périodes de la journée et de nature à impacter les délais de téléchargement ou l'accessibilité aux informations, et
        (ii) que l'internet est un réseau ouvert et, qu'en conséquence, les informations qu'il véhicule ne sont pas protégées contre les risques de
        détournement, d'intrusion dans son système, de piratage des données, programmes et fichiers de son système, de contamination par des virus
        informatiques, et (iii) qu'il lui appartient de prendre toutes les mesures appropriées de façon à protéger les données, fichiers ou programmes stockés
        dans son système contre la contamination par des virus comme des tentatives d'intrusion dans son système.
      </div>
      <div class="title">ARTICLE 10 - DONNÉES PERSONNELLES</div>
      <div class="paragraph">
        <RouterLink class="link" :to="{ name: 'rgpd' }"
          >Les informations fournies à l’Utilisateur au titre de ses données à caractère personnel sont accessibles ici,</RouterLink
        >
        (Règlement UE 2016/679 du 27 avril (RGPD) et loi n°78-17 du 6 janvier 1978).
        <br />
        <br />
        Pour toute question relative au traitement des données à caractère personnel, l’Utilisateur peut contacter Infogreffe à l’adresse suivante : Infogreffe
        à l’attention du Délégué à la protection des données, 5-7 Avenue de Paris, 94300 Vincennes.
        <br />
        <br />
        Les demandes des Utilisateurs relatives au traitement des données à caractère personnel peuvent également être adressées par mail à l’adresse suivante :
        <a class="link" href="mailto:protection-donnees@infogreffe-siege.fr">protection-donnees@infogreffe-siege.fr</a>.
        <br />
        <br />
        Le Délégué à la protection des données, est le cabinet d’avocats AARPI VIRTUALEGIS, situé 5 rue Jean-Baptiste Dumas, 75017 Paris
      </div>
      <div class="title">ARTICLE 11 - LOI APPLICABLE – COMPETENCE</div>
      <div class="paragraph">
        11.1 Les CGUV sont soumises au droit français.
        <br />
        <br />
        11.2 Conformément aux articles L.612-1 à L.612-5 du Code de la consommation, l’Utilisateur Consommateur a le droit de recourir gratuitement à un
        médiateur de la consommation en vue de la résolution amiable du litige qui l'oppose à un professionnel. Le Client Consommateur est néanmoins informé que
        le litige ne pourra être examiné par le médiateur de la consommation que s’il est en mesure de justifier avoir tenté au préalable de résoudre son litige
        directement auprès d’INFOGREFFE par une réclamation écrite adressée par lettre recommandée avec accusé de réception, et que cette réclamation n’ait pas
        aboutie ou soit restée sans réponse dans un délai de deux (2) mois.
        <br />
        <br />
        11.3 INFOGREFFE étant un groupement de nature civile, il est rappelé que tout éventuel litige se rapportant à la validité, l'interprétation ou
        l'exécution des présentes CGUV relève des juridictions civiles.
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
.view {
  display: flex;
  justify-content: center;
  padding-top: 90px;
}

.container {
  margin: 96px 0;
  max-width: 987px;

  .main-title {
    font-weight: 500;
    font-size: 28px;
    line-height: 30px;
    display: flex;
    align-items: center;
    color: colors.$darkblue-color;
    margin-bottom: 24px;
  }

  .title {
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;

    display: flex;
    align-items: center;

    color: colors.$text-color;

    margin-bottom: 12px;
  }

  .paragraph {
    margin-bottom: 24px;
  }

  .link {
    color: colors.$main-color;
    text-decoration: underline;
    cursor: pointer;
    transition: 0.1s;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
